import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
import { googleMapsStyles } from '../lib/googleMapsStyles';
import pinURL from '../../images/map-pin.svg?url';

export async function contactMap(mapElement) {
  if (!mapElement) return;

  const API_KEY = import.meta.env.VITE_GMAPS_API_KEY;
  if (!API_KEY) {
    console.error(
      'VITE_GMAPS_API_KEY environment variable is missing, see: /.env.example',
    );
    return;
  }

  const lat = parseFloat(mapElement.dataset.lat || 0);
  const lng = parseFloat(mapElement.dataset.lng || 0);
  const zoom = parseFloat(mapElement.dataset.zoom || 17);

  if (!lat || !lng) return;

  const location = { lat, lng };

  // Set loader options.
  setOptions({
    key: import.meta.env.VITE_GMAPS_API_KEY, // see .env
    v: 'weekly',
  });

  const [{ Map }, { Marker }] = await Promise.all([
    google.maps.importLibrary('maps'),
    google.maps.importLibrary('marker'),
  ]);

  const mapOptions = {
    center: location,
    zoom,
    styles: googleMapsStyles,
    disableDefaultUI: true,
    draggable: true,
    gestureHandling: 'cooperative',
    // mapId: 'DEMO_ID',
  };

  const map = new Map(mapElement, mapOptions);

  new Marker({
    position: location,
    map,
    icon: pinURL,
  });
}
